import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import Edit from '@/components/Edit'
import Associate from '@/components/Associate'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Hello',
            component: Hello
        },
        {
            path: '/edit/:id',
            name: 'Edit',
            component: Edit
        },
        {
            path: '/associate',
            name: 'Associate',
            component: Associate
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js